<template>
  <div>
    <ph-tabs :list="tabs" @tabClick="onTabChange" />
    <div
      v-for="(item, index) in list"
      :key="index"
      @click="showDetail(item)"
      class="list-item"
    >
      <img
        :src="item.picurl || require('@assets/img_news.png')"
        alt=""
        style="width: 4rem;"
      />
      <div>{{ item.title }}</div>
      <van-icon name="arrow" style="margin-right: 0;margin-left: auto;" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabs: [],
      list: [],
      content: ""
    };
  },
  created() {
    this.$http.post(this.$api.REFERENCE_NEWS_LIST_TYPE).then(res => {
      this.tabs = res.map(item => {
        return {
          name: item.newstypename,
          ...item
        };
      });
      this.loadList(res[0].newstype);
    });
  },
  methods: {
    showDetail(item) {
      this.$router.push({
        name: "healthy-detail",
        query: {
          id: item.id,
          type: "news"
        }
      });
    },
    onTabChange(_, tab) {
      if (this.tabs.length > tab) {
        this.loadList(this.tabs[tab].newstype);
      }
    },
    loadList(id) {
      this.$http
        .post(this.$api.REFERENCE_NEWS_LIST, {
          newstype: id,
          pageNum: 1,
          pageSize: 100
        })
        .then(res => {
          this.list = res.list;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.list-item {
  display: flex;
  align-items: center;
  margin: 0.9rem;
  padding: 1rem 0;
  border-bottom: 1px solid #f4f4f4;

  img {
    margin-right: 0.5rem;
    border-radius: 0.4rem;
  }
}
</style>

<style lang="less">
.van-dialog__message {
  overflow-x: hidden;
}
</style>
